$(document).ready(function () {
  $('.js-slider').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: true,
    items: 1,
    mouseDrag:false,
    autoplay: true,
    autoplayTimeout: 15000,
    smartSpeed: 800,
    animateIn:'animate__fadeIn',
    //animateOut: 'animate__fadeOut',
    navText: ["<span class='prev iconFont iconFont--xsmall iconFont--cwhite'></span>","<span class='next iconFont iconFont--xsmall iconFont--cwhite'></span>"]
  });
  $(".downArrow").on("click", function(){
    var body = $("html, body");
    body.stop().animate({scrollTop: $(".mainContainer__home").offset().top - $(".header.short").height()}, 900, 'swing');
  });

  AOS.init({disable: 'mobile'});

  // lazyload
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();


  // $(".offerSlider__title").lettering('words');

  $('.reference__inner.owl-carousel').owlCarousel({
    items: 1,
    margin: 40,
    loop: true,
    nav: true,
    animateOut: 'animate__backOutLeft',
    animateIn: 'animate__backInRight',
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 4000,
    mouseDrag: false,
    navText: ["<span class='prev iconFont iconFont--xsmall iconFont--cwhite'></span>","<span class='next iconFont iconFont--xsmall iconFont--cwhite'></span>"]
  });

  //language
  $('.language__select').on('click', function() {
    $('.language__list').slideToggle('fast');
    return false;
  });

  $('a[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if( target.length ) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  });

  $('.styledFormItems--passwordLogin').on("click", function () {
    var x = document.getElementById("password_login");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  });

  $('.styledFormItems--password').on("click", function () {
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  });

  $('.styledFormItems--passwordConfirm').on("click", function () {
    var x = document.getElementById("password_confirm");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  });

  $('.styledFormItems--newPassword').on("click", function () {
    var x = document.getElementById("new_password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  });

  $('.styledFormItems--oldPassword').on("click", function () {
    var x = document.getElementById("old_password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  });

  $('.styledFormItems--newPasswordConfirmation').on("click", function () {
    var x = document.getElementById("new_password_confirmation");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  });


  $(".landingPage__image").on("click","a", function (event) {
    event.preventDefault();
    var id  = $(this).attr('href'),
      top = $(id).offset().top;
    $('body,html').animate({scrollTop: top}, 994);
  });


  document.querySelectorAll('.mainContainer__offer-single .module').forEach(function(el, i) {
    el.classList.remove('module');
    el.classList.add('single__module');
  });

  document.querySelectorAll('.offerSingleDetails__slider .slick-arrow').forEach(function(el, i) {
    el.innerHTML = '';
  });

  $('.offerSingleDetails__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><span class="prev iconFont iconFont--mini"></span></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"><span class="next iconFont iconFont--mini"></span></button>',
    asNavFor: '.offerSingleDetails__nav'
  });
  $('.offerSingleDetails__nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.offerSingleDetails__slider',
    focusOnSelect: true
  });

  $('.offerSingleDetails__tabs div.contentBlock:nth-child(1)').attr('id', 'one-panel').addClass('panel');
  $('.offerSingleDetails__tabs div.contentBlock:nth-child(2)').attr('id', 'two-panel').addClass('panel');
  $('.offerSingleDetails__tabs .downloads').attr('id', 'three-panel').addClass('panel');
  $('.offerSingleDetails__tabs .module:last-child').attr('id', 'four-panel').addClass('panel');
  $('.offerSingleDetails__tabs .module:last-child div.contentBlock:nth-child(1)').removeAttr('id', 'one-panel').removeClass('panel');

  // var wow = new WOW();
  // wow.init();

  var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if(header!==null){
      if ((body.scrollTop || ms.scrollTop) >= 100) {
        header.classList.add('short');
      } else {
        header.classList.remove('short');
      }
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax', {
      center: true
    });
  }

  $(".sliderOwl__arrowDown").on("click", function (e) {
    e.preventDefault();
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.intro').offset().top - 100
    }, 1500, 'swing');
  });

  $('#arrowMap').on('click', function() {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.contactPlaceMap').offset().top - 200
    }, 1500, 'swing');
  });

  var hash= window.location.hash
  var target = $(hash);
  headerHeight = 120;
  if (target.length) {
    console.log(target.length);
    $('html,body').stop().animate({
      scrollTop: target.offset().top - 125 //offsets for fixed header
    }, 'linear');
  }
  $("img").each(function () {
    if ($(this).css("float") === "left") { $(this).addClass("imgLeft"); }
    if ($(this).css("float") === "right") { $(this).addClass("imgRight"); }
  });

  $(window).on('mousemove', function(e) {
    var w = $(window).width();
    var h = $(window).height();
    var offsetX = 0.5 - e.pageX / w;
    var offsetY = 0.5 - e.pageY / h;

    $(".aboutUs .parallax").each(function(i, el) {
      var offset = parseInt($(el).data('offset'));
      var translate = "translate3d(" + Math.round(offsetX * offset) + "px," + Math.round(offsetY * offset) + "px, 0px)";

      $(el).css({
        '-webkit-transform': translate,
        'transform': translate,
        'moz-transform': translate
      });
    });
  });

  if ( $('.js-select2').length ) {
    $(".js-select2").select2({
      minimumResultsForSearch: -1,
      width: "100%",
      language: "pl",
      placeholder:$(this).data("placeholder")
    });
    $(".js-select2").on("select2:close", function (e) {
      //$(this).valid();
    });
  }

  //$('.meetings__img').hide();
  //$('.meetings__img--all').show();

  $('.calendar').owlCarousel({
    loop: false,
    margin: 0,
    nav: true,
    dots: false,
    items: 3,
    mouseDrag:false,
    autoplay: false,
    animateIn:'animate__fadeIn',
    navText: ["<span class='prev iconFont iconFont--mini iconFont--cwhite'></span>","<span class='next iconFont iconFont--mini iconFont--cwhite'></span>"],
    responsive: {
      480: {
        items: 4
      },
      600: {
        items: 5
      },
      900: {
        items: 6
      },
      1240: {
        items: 7
      }
    }
  });

  $(".button--calendar").on("click",function() {
    if($(".calendar__dayTime.active").length==1){
      $(".meetings__formBox--first").css("display", "none");
      $(".meetings__formBox--second").css("display", "block");
      $(".meetings__formBox--last").css("display", "none");
    }
  });

  $("[data-term-place],[data-term-person]").bind("change",function(){
    var placeId = $("[data-term-place]").find('option:selected').val();
    var personId = $("[data-term-person]").find('option:selected').val();

    if(placeId!="" && personId!=""){
  		$.post('/module/schedule',{
  			'place_id':placeId,
        'person_id':personId,
  			'_token': window.Laravel.csrfToken
  		},function(response){
  			$('[data-calendar]').trigger('replace.owl.carousel', response).trigger('refresh.owl.carousel');
  		});
    }
	});

  $(".button--payment").on("click",function() {

    $("[data-visit-form]").find('input[name="phone"]').parent().find('label.error2').remove();
    $("[data-visit-form]").find('input[name="email"]').parent().find('label.error2').remove();

    var valid1 = false, valid2 = false;

    if($("[data-visit-form]").valid()){
      var value = $("[data-visit-form]").find('input[name="phone"]').val();
      if(!/^[0-9]{9}$/.test(value)){
        var msg = $("[data-visit-form]").find('input[name="phone"]').attr('title');
        var label = $("[data-visit-form]").find('input[name="phone"]').parent().find('label.error2').length;
        if(label)
          $("[data-visit-form]").find('input[name="phone"]').parent().find('label.error2').attr('style','display:block;').html(msg);
        else
          $("[data-visit-form]").find('input[name="phone"]').parent().append('<label class="error2">'+msg+'</label>');
      }else{
        valid1 = true;
        console.log('remove tel');
      }

      var value = $("[data-visit-form]").find('input[name="email"]').val();
      if(!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(value)){
        var msg = $("[data-visit-form]").find('input[name="email"]').attr('title');
        var label = $("[data-visit-form]").find('input[name="email"]').parent().find('label.error2').length;
        if(label)
          $("[data-visit-form]").find('input[name="email"]').parent().find('label.error2').attr('style','display:block;').html(msg);
        else
          $("[data-visit-form]").find('input[name="email"]').parent().append('<label class="error2">'+msg+'</label>');
      }else{
        valid2 = true;
        console.log('remove email');
      }
    }

    if($("[data-visit-form]").valid() && $(".payment.active").length==1 && $('form')[0].checkValidity() && valid1 && valid2){
      var payment = $(".payment.active").attr('data-payment');
      $.post('/payment/send',{
        'payment': payment,
        'place' : $("select[name='place']").find('option:selected').val(),
        'person' : $("select[name='person']").find('option:selected').val(),
        'date' : $('.calendar__dayTime.active').closest("[data-term-date]").attr('data-term-date'),
        'time' : $('.calendar__dayTime.active').html().trim(),
        'name' : $("input[name='name']").val(),
        'phone' : $("input[name='phone']").val(),
        'email' : $("input[name='email']").val(),
        '_token': window.Laravel.csrfToken
      },function(response){
        if(response.code==1){
          $(".meetings__formBox--first").css("display", "none");
          $(".meetings__formBox--second").css("display", "none");
          $(".meetings__formBox--last").css("display", "block");
          if(payment=="online"){
            setTimeout(function(){
              top.location.href = response.msg;
            },1000);
          }
        }else{
          alert(response.msg);
        }
      },"json");
    }
  });

  $(".payment--cash").removeClass("active");
  $(".payment--online").removeClass("active");
  $(".calendar__dayTime").removeClass("active");

  $("body").on("click",".calendar__dayTime",function() {
    $(".calendar__dayTime").removeClass("active");
    $(this).not(".off").not(".reserved").addClass("active");
  });

  $(".payment--online").on("click",function() {
    $(".payment--online").addClass("active");
    $(".payment--cash").removeClass("active");
  });
  $(".payment--cash").on("click",function() {
    $(".payment--online").removeClass("active");
    $(".payment--cash").addClass("active");
  });

  $('.meetings__select--specialist').change(function() {
    $('.meetings__img').hide();
    $('[data-person-image="'+$(this).val()+'"]').show(); //show selected option's respective element
  });

  if($("[data-term-payment]").length ==1 && top.location.href.indexOf('?success')!=-1){
    $(".meetings__formBox--first").css("display", "none");
    $(".meetings__formBox--second").css("display", "none");
    $(".meetings__formBox--last").css("display", "block");
	}

});
